'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  PAGE_SECTION_QUERY
} from "./chunk-46Z5IX3R.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  SECTIONS_LIMIT
} from "./chunk-HVHRQLH6.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  requestWithRateLimitHandling
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/zones/detail.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var ZONE_BASE_QUERY = gql`
query getZoneDetail($lang: String, $limit: Int, $skip: Int, $where: ZoneFilter, $order: [ZoneOrder]) {
  zoneCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    items{
      __typename
      sys { id }
      id
      title
      subtitle
      slug
      description
      startingPrice
      featuredBanner{${IMAGE_QUERY}}
      banner{${IMAGE_QUERY}}
      backgroundColor
      carousalCollection(limit: 40){items{${IMAGE_QUERY}}}
      zoneLogo{${IMAGE_QUERY}}
      zoneIcon{${IMAGE_QUERY}}
      sponsorLogo{${IMAGE_QUERY}}
      button{ label link }
      location{${LOCATION_QUERY}}
      schedule{${SCHEDULE_QUERY}}
      season{title slug}
      showResellBanner
      booklet { title text link }
      infoListCollection(limit:10){
        items {
            title
            description{json}
            icon{${IMAGE_QUERY}}
        }
      }
    }
  }
}
`;
var ZONE_SECTIONS_QUERY = gql`
  query getZoneSections($lang: String, $limit: Int, $skip: Int, $where: ZoneFilter, $order: [ZoneOrder]) {
    zoneCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
      items {
        sys { id }
        slug
        webSectionsCollection(limit: ${SECTIONS_LIMIT}) {
          items {
            __typename
            ${PAGE_SECTION_QUERY}
          }
        }
      }
    }
  }
`;
var getZoneDetail = (_a) => __async(void 0, null, function* () {
  var _b = _a, { includeSections = true } = _b, props = __objRest(_b, ["includeSections"]);
  var _a2, _b2, _c;
  const vars = __spreadProps(__spreadValues({}, props), {
    lang: getContentfulSafeLocale(props.lang)
  });
  try {
    const basePromise = yield requestWithRateLimitHandling(minifyGqlQuery(ZONE_BASE_QUERY), vars);
    const sectionsPromise = includeSections ? requestWithRateLimitHandling(
      minifyGqlQuery(ZONE_SECTIONS_QUERY),
      vars
    ) : Promise.resolve(null);
    const [baseRes, secRes] = yield Promise.all([basePromise, sectionsPromise]);
    const baseItems = (_a2 = baseRes.zoneCollection.items) != null ? _a2 : [];
    if (includeSections && secRes) {
      const sectionZone = (_b2 = secRes.zoneCollection.items) == null ? void 0 : _b2[0];
      const baseZone = baseItems[0];
      const mergedZone = baseZone ? __spreadProps(__spreadValues({}, baseZone), {
        webSectionsCollection: (_c = sectionZone == null ? void 0 : sectionZone.webSectionsCollection) != null ? _c : baseZone.webSectionsCollection
      }) : void 0;
      return {
        rateLimited: baseRes.rateLimited,
        data: mergedZone
      };
    }
    return {
      rateLimited: baseRes.rateLimited,
      data: baseItems[0]
    };
  } catch (error) {
    throw new Exception({ error, name: "getZoneDetailException" });
  }
});
var useGetZoneDetail = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getZoneDetail", props],
    queryFn: () => getZoneDetail(props)
  }, options));
};

export {
  useGetZoneDetail
};
//# sourceMappingURL=chunk-7X22GW3G.mjs.map